
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.198 11.97L9.264 1.644a1.682 1.682 0 00-1.449-.83 1.677 1.677 0 00-1.448.83L.433 11.971a1.601 1.601 0 000 1.613 1.654 1.654 0 001.448.828H13.75a1.65 1.65 0 001.666-1.635c0-.283-.075-.562-.217-.806zM7.272 6.253a.545.545 0 01.927-.384c.102.102.159.24.159.384v2.72a.545.545 0 01-.543.544.542.542 0 01-.543-.544v-2.72zm.543 5.984a.813.813 0 01-.798-.975.817.817 0 01.64-.64.812.812 0 01.972.8.817.817 0 01-.814.815z","fill":"#0D66D6"}})])
          )
        }
      }
    